import LessonViewer from '../components/LessonViewer';
import { algebra2Lessons } from './lessons';

export default function Algebra2FreeLessons() {
  return <LessonViewer lessons={algebra2Lessons} />;
}